import { Icon, IconClose } from '@maverick/ui';
import { FC } from 'react';
import { useRouter } from 'next/router';

import * as Styled from './Seating.styled';

interface SeatingModalProps {
	onClose?: () => void;
}
export const SeatingModal: FC<SeatingModalProps> = ({ onClose, children }) => {
	const router = useRouter();

	const handleClose = () => {
		if (onClose) {
			onClose();
			return;
		}

		router.push('/');
	};

	return (
		<Styled.Modal>
			<Styled.ModalContent>
				<Styled.ModalClose onClick={handleClose}>
					<Icon icon={IconClose} />
				</Styled.ModalClose>
				<Styled.ModalChildren>{children}</Styled.ModalChildren>
			</Styled.ModalContent>
		</Styled.Modal>
	);
};
